import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import Skeleton from '../ui/Skeleton'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, isTokenExpired } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="space-y-4 w-64">
          <Skeleton variant="heading" className="w-full" />
          <Skeleton variant="text" className="w-3/4" />
          <Skeleton variant="text" className="w-1/2" />
        </div>
      </div>
    )
  }

  // If token is expired, show the modal (which is rendered globally) but don't redirect
  // The modal will handle navigation when unlock button is clicked
  if (isTokenExpired) {
    return children // Still render children so modal can be shown
  }

  // Only redirect if not authenticated and token is not expired
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute

